import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_INVOICEROUTE_ID_LOADING = 'GET_INVOICEROUTE_ID_LOADING';
export const GET_INVOICEROUTE_ID_SUCCESS = 'GET_INVOICEROUTE_ID_SUCCESS';
export const GET_INVOICEROUTE_ID_REJECT = 'GET_INVOICEROUTE_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getInvoiceRouteIdLoading = () => ({ type: GET_INVOICEROUTE_ID_LOADING });
export const getInvoiceRouteIdSuccess = (payload) => ({ type: GET_INVOICEROUTE_ID_SUCCESS, payload });
export const getInvoiceRouteIdReject = (payload) => ({ type: GET_INVOICEROUTE_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getInvoiceRouteIdRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/InvoiceRoutes/${id}`, options);
};